export const twoPlans = [
  { value: 'ESLELD', label: 'ESL/ELD' },
  { value: 'IEP',    label: 'IEP' },
  { value: 'NA',     label: 'N/A' },
  { value: '',       label: 'x' },
]

export const threePlans = [
  { value: 'ESLELD', label: 'ESL/ELD' },
  { value: 'IEP',    label: 'IEP' },
  { value: 'French', label: 'French' },
  { value: '',       label: 'x' },
]

export const fourPlans = [
  { value: 'ESLELD', label: 'ESL/ELD' },
  { value: 'IEP',    label: 'IEP' },
  { value: 'French', label: 'French' },
  { value: 'NA',     label: 'N/A' },
  { value: '',       label: 'x' },
]

export const sixPlans = [
  { value: 'ESLELD',    label: 'ESL/ELD' },
  { value: 'IEP',       label: 'IEP' },
  { value: 'Core',      label: 'Core' },
  { value: 'Immersion', label: 'Immersion' },
  { value: 'Extended',  label: 'Extended' },
  { value: 'NA',        label: 'N/A' },
  { value: '',          label: 'x' },
]

export const threeResults = [
  { value: 'PWD', label: 'Progressing With Difficulty' },
  { value: 'PW',  label: 'Progressing Well' },
  { value: 'PVW', label: 'Progressing Very Well' },
  { value: '',    label: 'x' },
]

export const selectItems = [
  { value: 'E', label: 'E' },
  { value: 'G', label: 'G' },
  { value: 'S', label: 'S' },
  { value: 'N', label: 'N' },
  { value: '',  label: 'x' },
]
